import { colors as globalColors } from "./template/colors";
import { shadows as globalShadows } from "./template/shadows";
import { borders as globalBorders } from "./template/borders";
import { spacings as globalSpacings } from "./template/spacings";
import { 
  fontSizes as globalFontSizes, 
  fontWeights as globalFontWeights 
} from "./template/typographys";

export const colors = globalColors;
export const shadows = globalShadows;
export const borders = globalBorders;
export const spacings = globalSpacings; 
export const fontSizes = globalFontSizes;
export const fontWeights = globalFontWeights;